import React, { useEffect, useState } from "react";
import { LP_FAKE_FORM_STEPS as STEPS } from "../../lib/constants";
import { Step, useStepper } from "../ui/stepper";

const easeLoading = (t) => {
  if (t < 0.3) {
    // Fast start - cubic ease in
    return 2.5 * t * t * t;
  } else if (t < 0.5) {
    // Medium speed
    return 0.27 + (0.15 * (t - 0.3)) / 0.2;
  } else if (t < 0.7) {
    // Slowing down
    return 0.42 + (0.25 * (t - 0.5)) / 0.2;
  } else if (t < 0.9) {
    // Much slower - approaching the end
    return 0.67 + (0.18 * (t - 0.7)) / 0.2;
  } else {
    // MUCH slower at the end - quintic ease out for dramatic slowdown
    const adjustedT = (t - 0.9) / 0.1;
    return 0.85 + 0.15 * (1 - Math.pow(1 - adjustedT, 6));
  }
};

export const LandingFormCreate = ({ data }) => {
  const [progress, setProgress] = useState(0);
  const { navigate, currentStep } = useStepper();

  const visualProgress = easeLoading(progress / 100) * 100;
  const isAlmostComplete = visualProgress >= 85;

  useEffect(() => {
    if (currentStep !== STEPS.CREATE) return;

    const interval = setInterval(() => {
      setProgress((prev) => prev + 1);
    }, 70);

    return () => clearInterval(interval);
  }, [currentStep]);

  useEffect(() => {
    if (progress >= 100) {
      navigate(STEPS.AUTH);
    }
  }, [progress]);

  return (
    <Step id={STEPS.CREATE}>
      <div className="h-[100dvh] flex items-center justify-center flex-col gap-8">
        <div className="flex items-center flex-col  gap-2">
          <img
            src={"/assets/heart_logo.png"}
            alt="heart logo icon"
            className="size-16"
          />

          <p className="text-4xl font-bold">Nectar AI</p>
        </div>

        <div className="w-[320px] h-2 rounded-full bg-background-300 relative overflow-hidden">
          <div
            className="inset-y-0 left-0 absolute h-full skeleton-loading-primary transition-all duration-300 ease-out"
            style={{
              width: `${easeLoading(progress / 100) * 100}%`,
            }}
          />
        </div>

        <div className="text-center">
          {isAlmostComplete ? (
            <p className="text-primary font-medium text-xl">Almost complete ✨</p>
          ) : (
            <p className="text-xl font-medium">Creating your AI Girlfriend...</p>
          )}
          <p className="text-foreground-800 text-center max-w-xs mt-2">
            This may take a few seconds. Please don{"'"}t close the page.
          </p>
        </div>
      </div>
    </Step>
  );
};
